export const SDK_VERSION = '7.79.0';
